import React, { Component } from "react";
import "./logged_out_frame.scss";
import { NavLink } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { If, classNames } from "react-extras";
import { withRouter } from "react-router";
import { matchPath } from "react-router-dom";
import get from "lodash/get";
import { getMegapodURL } from "../../../lib/config";

class LoggedOutFrame extends Component {
  getRolePathName = () => {
    var result = matchPath(this.props.location.pathname, "/:topLevelRoute/:role");
    return get(result, "params.role");
  };

  getLink = topLevelRoute => {
    let role = this.getRolePathName();
    let path = "/" + topLevelRoute;
    if (role) {
      path = path + "/" + role;
    }
    return path + window.location.search;
  };

  render() {
    return (
      <div
        className={classNames("logged-out-frame", this.props.className)}
        style={this.props.style}>
        <If condition={!this.props.hideHeader}>
          <div className="logged-out-frame__topbar clearfix">
            <div className="logged-out-frame__logo">
              <a href="https://redcircle.com" className="logged-out-frame__logo-link">
                <span>RedCircle</span>
              </a>
            </div>
            <div className="logged-out-frame__nav">
              <If condition={!this.props.hideSignIn}>
                <NavLink
                  className="redcircle-big-link"
                  to={this.props.signInLink || this.getLink("sign-in")}
                  activeClassName="logged-out-frame__nav-link--active">
                  Sign In
                </NavLink>
              </If>
              <If condition={!this.props.hideSignUp}>
                <a
                  className="redcircle-big-link"
                  href={
                    this.props.signUpLink ||
                    getMegapodURL() + "account-create" + window.location.search
                  }
                  activeClassName="logged-out-frame__nav-link--active">
                  {this.props.signInText || "Sign Up"}
                </a>
              </If>
            </div>
          </div>
        </If>
        <If condition={!!this.props.hideHeader}>
          <div className="clearfix" />
        </If>
        <div className="logged-out-frame__content container">
          <Row>
            <Col md={6} mdOffset={3} sm={12}>
              <If condition={!!this.props.title}>
                <h1 className="logged-out-frame__header">{this.props.title}</h1>
              </If>
              <If condition={this.props.subTitle}>
                <p className="logged-out-frame__welcome">{this.props.subTitle}</p>
              </If>
              <If condition={!this.props.noBar}>
                <hr className="redcircle-divider logged-out-frame__first-divider" />
              </If>
            </Col>
          </Row>
          {this.props.children}
        </div>
        <div className="logged-out-frame__footer">
          <hr className="redcircle-divider" />
          <div className="logged-out-frame__footer__copyright text-small">
            <small>© 2020 RedCircle Technologies Inc. All Rights Reserved.</small>
          </div>
          <div className="logged-out-frame__footer__links">
            <a className="redcircle-big-link" href="https://redcircle.com/privacy">
              <small>Privacy Policy</small>
            </a>
            <a className="redcircle-big-link" href="https://redcircle.com/terms">
              <small>Terms of Service</small>
            </a>
            <a className="redcircle-big-link" href="mailto:support@getredcircle.com">
              <small>Contact Us</small>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LoggedOutFrame);
